import { render, staticRenderFns } from "./DeleteSector.vue?vue&type=template&id=8de5b7c4&lang=html&"
import script from "./DeleteSector.vue?vue&type=script&lang=js&"
export * from "./DeleteSector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports